import { useEffect, useState } from 'react';
import AlertToUIBadge from 'util/AlertToUIBadge';
import AlertPreview from './AlertPreview';
import moment from 'moment';

const PastAlerts = ({ alerts }) => {
  const [pastAlerts, setPastAlerts] = useState(null);

  useEffect(() => {
    const pastAlertsData = alerts.map((alert, index) => {
      const data = {
        ...AlertToUIBadge(alert),
        date: alert.trigger_time,
        resolved: alert.resolved,
        expirationDate: alert.exp_time,
        reason: alert.exp_reason,
      };

      return (
        <AlertPreview key={index} data={data}>
          <div className='additional-info past-alert-additional-info'>
            <div className='additional-info-top'>
              <span className={`title ${data.resolved ? 'resolved' : 'expired'}`}>
                {data.resolved ? 'Resolved' : 'Expired '}
              </span>
              {data.expirationDate && (
                <span className='date'>
                  at {moment(data.expirationDate).format('LT')}
                </span>
              )}
            </div>
            {data.reason && (
              <div className='expiration-reason'>{data.reason}</div>
            )}
          </div>
        </AlertPreview>
      );
    });

    setPastAlerts(pastAlertsData);
  }, []);

  return (
    <div className='past-alerts-list'>
      <div className='side-panel-title'>Past alerts</div>
      <div className='full-view d-flex'>{pastAlerts}</div>
    </div>
  );
};

export default PastAlerts;
